export const LANGUAGE = {
  'en-us': 'en',
  th: 'th',
  'ja-jp': 'jp',
};
